// MUI Imports
import { useTheme } from '@mui/material/styles'

// Type Imports
import type { VerticalMenuContextProps } from '@menu/components/vertical-menu/Menu'

// Component Imports
import HorizontalNav, { Menu, MenuItem } from '@menu/horizontal-menu'
import VerticalNavContent from './VerticalNavContent'

// Hook Imports
import useVerticalNav from '@menu/hooks/useVerticalNav'

// Styled Component Imports
import StyledHorizontalNavExpandIcon from '@menu/styles/horizontal/StyledHorizontalNavExpandIcon'
import StyledVerticalNavExpandIcon from '@menu/styles/vertical/StyledVerticalNavExpandIcon'

// Style Imports
import menuItemStyles from '@core/styles/horizontal/menuItemStyles'
import menuRootStyles from '@core/styles/horizontal/menuRootStyles'
import verticalNavigationCustomStyles from '@core/styles/vertical/navigationCustomStyles'
import verticalMenuItemStyles from '@core/styles/vertical/menuItemStyles'
import verticalMenuSectionStyles from '@core/styles/vertical/menuSectionStyles'
import PermissionCheckWrapper from '@/SDK/PermissionCheckWrapper'
import AccessLevel from '@/SDK/AccessLevel'

type RenderExpandIconProps = {
  level?: number
}

type RenderVerticalExpandIconProps = {
  open?: boolean
  transitionDuration?: VerticalMenuContextProps['transitionDuration']
}

const RenderExpandIcon = ({ level }: RenderExpandIconProps) => (
  <StyledHorizontalNavExpandIcon level={level}>
    <i className='tabler-chevron-right' />
  </StyledHorizontalNavExpandIcon>
)

const RenderVerticalExpandIcon = ({ open, transitionDuration }: RenderVerticalExpandIconProps) => (
  <StyledVerticalNavExpandIcon open={open} transitionDuration={transitionDuration}>
    <i className='tabler-chevron-right' />
  </StyledVerticalNavExpandIcon>
)

const HorizontalMenu = () => {
  // Hooks
  const verticalNavOptions = useVerticalNav()
  const theme = useTheme()

  // Vars
  const { transitionDuration } = verticalNavOptions

  return (
    <HorizontalNav
      switchToVertical
      verticalNavContent={VerticalNavContent}
      verticalNavProps={{
        customStyles: verticalNavigationCustomStyles(verticalNavOptions, theme),
        backgroundColor: 'var(--mui-palette-background-paper)'
      }}
    >
      <Menu
        rootStyles={menuRootStyles(theme)}
        renderExpandIcon={({ level }) => <RenderExpandIcon level={level} />}
        menuItemStyles={menuItemStyles(theme, 'tabler-circle')}
        renderExpandedMenuItemIcon={{ icon: <i className='tabler-circle text-xs' /> }}
        popoutMenuOffset={{
          mainAxis: ({ level }) => (level && level > 0 ? 14 : 12),
          alignmentAxis: 0
        }}
        verticalMenuProps={{
          menuItemStyles: verticalMenuItemStyles(verticalNavOptions, theme),
          renderExpandIcon: ({ open }) => (
            <RenderVerticalExpandIcon open={open} transitionDuration={transitionDuration} />
          ),
          renderExpandedMenuItemIcon: { icon: <i className='tabler-circle text-xs' /> },
          menuSectionStyles: verticalMenuSectionStyles(verticalNavOptions, theme)
        }}
      >
        {/*<PermissionCheckWrapper permissionName={'Pages.Dashboard'} minAccessLevel={AccessLevel.READ}>*/}
        <MenuItem href='/' icon={<i className='tabler-dashboard' />}>
          Dashboard
        </MenuItem>
        {/*</PermissionCheckWrapper>*/}

        <PermissionCheckWrapper permissionName={'Pages.Users'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/users' icon={<i className='tabler-users' />} exactMatch={false} activeUrl='/users'>
            Users
          </MenuItem>
        </PermissionCheckWrapper>

        <PermissionCheckWrapper permissionName={'Pages.Teams'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/teams' icon={<i className='tabler-users' />}>
            Teams
          </MenuItem>
        </PermissionCheckWrapper>

        <PermissionCheckWrapper permissionName={'Pages.Roles and Permissions'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/roles' icon={<i className='tabler-circles' />}>
            Roles & Permissions
          </MenuItem>
        </PermissionCheckWrapper>

        <PermissionCheckWrapper permissionName={'Pages.Application'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/apps' icon={<i className='tabler-apps' />}>
            Application
          </MenuItem>
        </PermissionCheckWrapper>

        <PermissionCheckWrapper permissionName={'Pages.Audit Logs'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/audit' icon={<i className='tabler-file-isr' />}>
            Audit Logs
          </MenuItem>
        </PermissionCheckWrapper>

        <PermissionCheckWrapper permissionName={'Pages.Configuration'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/config' icon={<i className='tabler-settings' />}>
            Configuration
          </MenuItem>
        </PermissionCheckWrapper>

        <MenuItem href='/example' icon={<i className='tabler-code' />}>
          Example
        </MenuItem>

        <PermissionCheckWrapper permissionName={'Pages.Roles and Permissions'} minAccessLevel={AccessLevel.READ}>
          <MenuItem href='/test' icon={<i className='tabler-flask' />}>
            Testing
          </MenuItem>
        </PermissionCheckWrapper>
      </Menu>
      {/* <Menu
        rootStyles={menuRootStyles(theme)}
        renderExpandIcon={({ level }) => <RenderExpandIcon level={level} />}
        menuItemStyles={menuItemStyles(theme, 'tabler-circle')}
        renderExpandedMenuItemIcon={{ icon: <i className='tabler-circle text-xs' /> }}
        popoutMenuOffset={{
          mainAxis: ({ level }) => (level && level > 0 ? 14 : 12),
          alignmentAxis: 0
        }}
        verticalMenuProps={{
          menuItemStyles: verticalMenuItemStyles(verticalNavOptions, theme),
          renderExpandIcon: ({ open }) => (
            <RenderVerticalExpandIcon open={open} transitionDuration={transitionDuration} />
          ),
          renderExpandedMenuItemIcon: { icon: <i className='tabler-circle text-xs' /> },
          menuSectionStyles: verticalMenuSectionStyles(verticalNavOptions, theme)
        }}
      >
        <GenerateHorizontalMenu menuData={menuData(dictionary)} />
      </Menu> */}
    </HorizontalNav>
  )
}

export default HorizontalMenu
